import { VStack } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export function InputGroup({ children }: PropsWithChildren) {
  return (
    <VStack
      gap={4}
      maxW={{
        base: "100%",
        md: "75%",
      }}
    >
      {children}
    </VStack>
  );
}
